import { State as CartState } from './cart.state';
import { State as DesignsState } from './designs.state';

export const featureKey = 'rossmann-design';

export type State = {
	cart: CartState,
	designs: DesignsState,
};
